<template>
	<div class="content-wrapper">
		<div class="row">
			<div class="col-12 mb-primary">
				<div class="card card-with-shadow border-0 h-100">
					<div class="card-header p-primary bg-transparent">
						<h5 class="card-title m-0">
							Create Event Registration
						</h5>
					</div>
					<app-overlay-loader v-if="preloader" />
					<div class="card-body">
						<form
							ref="form"
							data-url="/transaction/event"
							class="mb-0"
							:class="{ 'loading-opacity': preloader }"
						>
							<div class="row">
								<div class="col-md-12">
									<app-breadcrumb page-title="Header" />
								</div>
							</div>
							<hr
								style="
									border-top: 2px solid black;
									font-weight: bold;
									margin-bottom: 20px !important;
								"
							/>
							<div class="row">
								<!-- Transaction Date -->
								<div class="col-md-4">
									<div class="form-group">
										<label>Transaction Date</label>
										<app-input
											type="date"
											v-model="inputs.transaction_date"
											:required="true"
											:placeholder="'Transaction Date'"
										/>
									</div>
								</div>
								<!-- Event Number -->
								<div class="col-md-4">
									<div class="form-group">
										<label>Event Number</label>
										<app-input
											type="text"
											v-model="inputs.number"
											:required="true"
											:placeholder="'Event Number'"
										/>
									</div>
								</div>
								<!-- Event Name -->
								<div class="col-md-4">
									<div class="form-group">
										<label>Event Name</label>
										<app-input
											type="text"
											v-model="inputs.name"
											:required="true"
											:placeholder="'Event Name'"
										/>
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-md-4">
									<div class="form-group default-file">
										<label> Event Banner </label>
										<app-input
											type="file"
											:label="'Upload Banner'"
											v-model="inputs.banner"
										/>
										<small class="text-muted font-italic">
											<ul>
												<li>
													File type: JPG, PNG, GIF
												</li>
												<li>File size: 2MB</li>
												<li>Dimension: 1700 x 300</li>
												<!-- <li>Dimension: 1920 x 1080</li> -->
											</ul>
										</small>
									</div>
								</div>
								<!-- Total Adult -->
								<div class="col-md-2">
									<div class="form-group">
										<label>Total Adult</label>
										<app-input
											type="number"
											v-model="inputs.total_adult"
											:required="true"
											:placeholder="'Total Adult'"
										/>
									</div>
								</div>
								<!-- Total Child -->
								<div class="col-md-2">
									<div class="form-group">
										<label>Total Child</label>
										<app-input
											type="number"
											v-model="inputs.total_child"
											:required="true"
											:placeholder="'Total Child'"
										/>
									</div>
								</div>
							</div>
							<div class="row">
								<!-- Published to -->
								<div class="col-md-12">
									<div
										class="form-group form row align-items-center"
									>
										<label class="col-sm-2 mb-sm-0">
											Published to
										</label>
										<app-input
											class="col-sm-8"
											type="multi-select"
											:list="publishedToLists"
											:isAnimatedDropdown="true"
											placeholder="Published to"
											v-model="inputs.publish_to"
										/>
									</div>
								</div>
							</div>
							<div class="mt-5 action-buttons">
								<button
									type="submit"
									class="btn btn-primary mr-2"
									@click.prevent="submit"
								>
									{{ $t("submit") }}
								</button>
								<button
									type="submit"
									class="btn btn-secondary"
									@click.prevent="clear"
								>
									{{ $t("clear") }}
								</button>
							</div>
						</form>

						<div class="row">
							<div class="col-md-12 mt-8">
								<master-event-registration-detail-table></master-event-registration-detail-table>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin.js";

export default {
	name: "EventRegistrationForm",
	mixins: [FormMixin],
	data() {
		return {
			preloader: false,
			inputs: {
				gender: "male",
			},
			publishedToLists: [
				{ id: 1, value: "Instagram" },
				{ id: 2, value: "Facebook" },
				{ id: 3, value: "Website" },
				{ id: 4, value: "Family" },
				{ id: 5, value: "Friend" },
				{ id: 6, value: "School" },
				{ id: 7, value: "Events" },
				{ id: 8, value: "Flyer/Leaflet" },
				{ id: 9, value: "Internet Search" },
				{ id: 10, value: "Other" },
			],
		};
	},
	methods: {
		beforeSubmit() {
			this.preloader = true;
		},

		submit() {
			// Perform validation before submitting
			if (this.validateInputs()) {
				this.beforeSubmit();
				// dummy banner
				this.inputs.banner = "https://picsum.photos/200/300";
				this.save(this.inputs);
			} else {
				// Handle validation error (e.g., show error messages)
				this.$toastr.e(
					"Validation error. Please fill in all required fields."
				);
			}
		},

		validateInputs() {
			// Perform your validation checks here
			// Example: Check if required fields are filled
			if (
				!this.inputs.transaction_date ||
				!this.inputs.number ||
				!this.inputs.name ||
				!this.inputs.banner ||
				this.inputs.total_adult === undefined ||
				this.inputs.total_child === undefined ||
				!this.inputs.publish_to
			) {
				return false;
			}

			// Additional validation checks can be added based on your requirements

			return true;
		},

		afterSuccess(res) {
			this.$toastr.s(res.data.message);
		},

		afterFinalResponse() {
			this.preloader = false;
			this.inputs = {};
		},

		afterError(res) {
			this.$toastr.e(res.data.message);
		},

		clear() {
			this.inputs = {};
			this.fieldStatus = {
				isSubmit: false,
			};
		},
	},
};
</script>

<style scoped>
.mt-8 {
	margin-top: 40px;
}
.card {
	box-shadow: 0 18px 20px rgba(0, 0, 0, 0.2); /* You can adjust the values to control the shadow effect */
}
.section-separator {
	background-color: #007bff; /* Choose your desired background color */
	padding: 10px 15px; /* Adjust the padding as needed */
	border-radius: 5px; /* Add rounded corners if desired */
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* Add a subtle shadow */
}

.section-separator h6 {
	margin: 0; /* Remove any default margin for the heading */
}
</style>
